// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"361":"ed25db57","688":"020a6065","934":"6b717718"}[chunkId] + ".chunk.js";
};